import React, { useState } from "react";
import { Link } from "react-router-dom";
import { authAPI } from "../../services/api";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import "../../styles/Forgot.css";

const Forgot = () => {
  const [email, setEmail] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [error, setError] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false); // ✅ Added this line

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      toast.warning("Email is required");
      return;
    }

    // Basic email validation
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      toast.error("Please enter a valid email address");
      return;
    }

    try {
      setLoading(true);
      const response = await authAPI.forgotPassword(encodeURIComponent(email));

      if (response.status === 200) {
        toast.success("Password reset link sent to your email 📧");
        setEmail("");
      }
    } catch (error) {
      if (error.response) {
        const message = error.response.data || "Something went wrong!";
        toast.error(message);
      } else {
        toast.error("Network error. Please try again later.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-container">
      {/* Toast notifications */}
      <ToastContainer position="top-right" autoClose={3000} theme="light" />

      <div className="forgot-box">
        {/* Logo Section */}
        <div className="forgot-logo-container" style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
          <img
            src="/clustrops-logo.png"
            alt="ClustrOps"
            style={{ height: 180, objectFit: 'contain' }}
          />
        </div>

        <h2>Forgot Password</h2>
        <p className="forgot-subtext">
          Enter your email address and we’ll send you a link to reset your password.
        </p>

        <form onSubmit={handleSubmit} className="forgot-form">
          <div className="forgot-form-group">
            <label>Email *</label>
            <input
              type="email"
              placeholder="Enter your registered email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={error ? "forgot-error" : ""}
              disabled={loading}
            />
            {error && <span className="forgot-error-text">{error}</span>}
          </div>

          <button type="submit" className="forgot-btn" disabled={loading}>
            {loading ? "Sending..." : "Send Reset Link"}
          </button>

          {success && <p className="forgot-success-text">{success}</p>}

          <p className="forgot-back-link">
            <Link to="/">← Back to Login</Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default Forgot;



// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import "../../styles/Forgot.css";

// const Forgot = () => {
//   const [email, setEmail] = useState("");
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setError("");
//     setSuccess("");

//     if (!email.trim()) {
//       setError("Email is required");
//     } else if (!/^\S+@\S+\.\S+$/.test(email)) {
//       setError("Please enter a valid email address");
//     } else {
//       setSuccess("Password reset link has been sent to your email.");
//       setEmail("");
//     }
//   };

//   return (
//     <div className="forgot-container">
//       <div className="forgot-box">
//         {/* Logo Section */}
//         <div className="forgot-logo-container">
//           <div className="forgot-circle-logo">
//             <span className="forgot-ats-logo">ATS</span>
//           </div>
//           <span className="forgot-circle-text">CIRCLE</span>
//         </div>

//         <h2>Forgot Password</h2>
//         <p className="forgot-subtext">
//           Enter your email address and we’ll send you a link to reset your password.
//         </p>

//         <form onSubmit={handleSubmit} className="forgot-form">
//           <div className="forgot-form-group">
//             <label>Email *</label>
//             <input
//               type="email"
//               placeholder="Enter your registered email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               className={error ? "forgot-error" : ""}
//             />
//             {error && <span className="forgot-error-text">{error}</span>}
//           </div>

//           <button type="submit" className="forgot-btn">
//             Send Reset Link
//           </button>

//           {success && <p className="forgot-success-text">{success}</p>}

//           <p className="forgot-back-link">
//             <Link to="/">← Back to Login</Link>
//           </p>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default Forgot;
